import { db } from "@/api/firebase";
import { City } from "@/models/City";
import { CityDetailsError } from "@/models/Errors/CityDetailsError";
import { isEmpty } from "lodash";

export default class ErrorsCity {
  cityData: City;
  errorObject = {} as CityDetailsError;
  constructor(cityData: City) {
    this.cityData = cityData;
  }

  checkCityErrors(): CityDetailsError {
    this.checkCountryCodeExists();
    this.checkCityDataHasName();
    if (!isEmpty(this.errorObject)) {
      /*db.ref("cities/" + this.cityData.slug + "/issues/err/").update(
        this.errorObject
      );*/
    } else {
      db.ref("cities/" + this.cityData.slug + "/issues/err/").remove();
    }
    return this.errorObject;
  }

  private checkCityDataHasName(): void {
    if (this.cityData.name.en.trim().length < 3) {
      this.errorObject.city_name_empty = {
        active: true,
        txt: {
          en: "Name is less than 3 characters.",
        },
      };
    } else {
      if (this.errorObject.city_name_empty !== undefined) {
        delete this.errorObject.city_name_empty;
      }
    }
  }
  private checkCountryCodeExists(): void {
    if (this.cityData.country.length == 0) {
      this.errorObject.country_code_missing = {
        active: true,
        txt: {
          en: "Countrycode is missing. Move centre_point to new location",
        },
      };
    } else {
      if (this.errorObject.country_code_missing !== undefined) {
        delete this.errorObject.country_code_missing;
      }
    }
  }
}
